<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-grid uk-grid-small uk-grid-width-1-2">
                <div></div>
                <div class="uk-text-right">
                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 weeks
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 26}"
                            @click.prevent="set_scope(26)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 52}"
                            @click.prevent="set_scope(52)"
                        >
                            1 year
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 260}"
                            @click.prevent="set_scope(260)"
                        >
                            5 years
                        </base-button>
                    </div>
                </div>
            </div>
            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <projections-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :y-max="ymax"
                        style="height: 600px;"
                    />
                </div>
            </div>
        </div>
    </report>
</template>

<script type="text/javascript">
import is_report from "./IsBigReport"
import uses_color_palette from "../../mixins/UsesColorPalette"

import Report from "./Report.vue"
import BaseButton from "../../ui/BaseButton"
import ProjectionsGraph from "./ProjectionsGraph.js"

export default {
    mixins: [is_report, uses_color_palette],
    components: {
        Report,
        BaseButton,
        ProjectionsGraph
    },
    computed: {
        chart_data () {
            const data = {
                labels: [],
                datasets: [
                    {
                        label: "Current",
                        backgroundColor: this.color_new.background,
                        borderColor: this.color_new.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "2nd Month",
                        backgroundColor: this.color_pending.background,
                        borderColor: this.color_pending.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "3rd Month",
                        backgroundColor: this.color_on_hold.background,
                        borderColor: this.color_on_hold.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "4th Month",
                        backgroundColor: this.color_active.background,
                        borderColor: this.color_active.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "5th Month",
                        backgroundColor: this.color_languished.background,
                        borderColor: this.color_languished.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "6th Month",
                        backgroundColor: this.color_declined.background,
                        borderColor: this.color_declined.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    },
                    {
                        label: "7th-12th Months",
                        backgroundColor: this.color_dead.background,
                        borderColor: this.color_dead.background,
                        fill: false,
                        categoryPercentage: 0.9,
                        barPercentage: 0.8,
                        data: []
                    }
                ]
            }
            const range_end = this.$moment().add(1, "weeks").startOf("week")
            const range_start = this.$moment(range_end).subtract(this.state.scope, "weeks")

            if(this.report) {
                const report_dataset = this.report.dataset

                let current_year = null
                Object.keys(report_dataset).forEach(date_string => {
                    const date = this.$moment(date_string)
                    if(date.isSameOrAfter(range_start) && date.isSameOrBefore(range_end)) {
                        let format = "MMM Do"
                        const date_year = date.format("YYYY")
                        if(current_year !== date_year) format = "YYYY " + format
                        current_year = date_year
                        data.labels.push(date.format(format))

                        report_dataset[date_string].forEach((value, index) => {
                            data.datasets[index].data.push(parseFloat(value))
                        })
                    }
                })

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.ymax = 0
                for(let loop = 0; loop < data.labels.length; loop++) {
                    let period_total = 0
                    data.datasets.forEach(dataset => {
                        period_total += dataset.data[loop]
                    })
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.ymax = Math.max(period_total, this.ymax)
                }
            }

            return data
        }
    },
    data () {
        return {
            report_id: "projections",

            default_state: {
                scope: 52,
                mode: "absolute",
                filter: "",
                user_id: 0,
                studio_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
